<template>
  <el-container class="main-content">
    <el-main class="right-panel" style="margin-right: 20px;">
      <div class="goods">
        <div class="goods-cell-group">
          <div class="description" v-html="product.detail"></div>
        </div>
      </div>
      <div class="buyFixBar">
        <el-row style="margin: 0 auto; width: 1240px; text-align:left">
          <el-col :span="17">
            <el-row>
              <el-col :span="6" class="goods-title">
                  当前产品：{{product.productName}}
              </el-col>
              <el-col :span="18" style="font-size: 14px; line-height: 30px;">
                <div style="float:left;">
                  <span>{{formatName}}</span>
                  <el-link :underline="false" type="primary" @click="onShowFormat">【选择规格】</el-link>
                </div>
                <div v-if="showFormat" class="good-format-list">
                  <span v-for="obj in product.formats" :key="obj.id"
                :class="{ 'good-format-item': true, 'good-format-item--active': obj.id == formatId }"
                @click="formatChange(obj.id)">{{obj.type}}</span>
                </div>
              </el-col>
            </el-row>

            <div class="product-selling-point">{{product.sellingPoint}}</div>
          </el-col>
          <el-col :span="4">
            <div class="goods-price">
              <span class="goods-price-info" v-html="formatPrice(this.price)"></span>
              <span class="goods-original-price">[<del>{{$Shared.formatPrice(product.originalPrice)}}</del>]</span>
            </div>
          </el-col>
          <el-col :span="3" style="padding-right: 40px; text-align:right; line-height:60px;">
            <el-button type="danger" :loading="loading" @click="submit">立即购买</el-button>
          </el-col>
        </el-row>
      </div>
    </el-main>
    <el-aside>
      <ProResumeHelper></ProResumeHelper>
    </el-aside>

  </el-container>
</template>

<script>
  import {
    getProductInfo, createOrder
  } from '~/api/mall.js';

  import ProResumeHelper from '~/components/ProResumeHelper';
  export default {
    components: {
      ProResumeHelper
    },
    data() {
      return {
        productId: this.$route.query.id,
        product: {},
        formatId: 0,
        showFormat: false,
        price: 0,
        formatName: '请选择：规格',
        mobile: '',
        email: '',
        loading: false,
      };
    },
    created() {
      if (this.productId) {
        this.refresh();
      }
    },
    methods: {
      formatPrice(price) {
        let val = this.$Shared.formatPrice(price);
        var prices = val.split('.');
        var intVal = prices[0];
        var desVal = prices[1];
        return '¥<strong>' + intVal + '</strong>' + '.' + desVal;
      },
      refresh() {
        this.getProductInfo();
      },
      getProductInfo() {
        var params = {
          productId: this.productId
        };
        getProductInfo(params).then(m => {
          if (m.errcode == 0) {
            this.product = m.data;
            if(this.product.formats){
              var formatId = this.product.formats[0].id;
              this.formatChange(formatId);
            }
          }
        });
      },
      formatChange(value) {
        this.formatId = value;
        let format = this.product.formats.find(x => x.id == this.formatId);
        if (format != null) {
          this.price = format.price;
          this.formatName = '已选择：' + format.type;
          this.showFormat = false;
        }
      },
      submit() {
        if (this.formatId <= 0) {
          this.$message('请选择规格');
          this.showFormat = true;
          return false;
        }

        let data = {
          product_id: this.productId,
          format_id: this.formatId,
          product_num: 1,
          coin: 0,
          buyer: this.$store.getters.fullName,
          mobile: this.$store.getters.mobile,
          address: '',
        };
        this.loading = true;
        createOrder(data).then( m => {
          this.loading = false;
          if(m.errcode === 0){            
            var planId = m.data.plan_id;
            this.$router.push({
              path: '/OrderPay',
              query: {
                planId: planId,
              }
            });
          } else {
            this.$message.error('创建订单失败，原因：' + m.errmsg);
          }
        });        
      },
      onShowFormat(){
        this.showFormat = !this.showFormat;
      },
    }
  };
</script>

<style scoped>
  .main-content {
    margin-bottom: 70px;
  }

  .buyFixBar {
    background-color: #fff;
    width: 100%;
    padding: 20px;
    height: 60px;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9;
    -webkit-box-shadow: 0 -2px 12px 0 hsla(0, 0%, 87.8%, .5);
    box-shadow: 0 -2px 12px 0 hsla(0, 0%, 87.8%, .5);
  }

  .left-text-content .el-collapse-item__content {
    font-size: 14px;
  }

  .good-format-list{
    float:left;
    margin-left: 10px;
  }
</style>